module.exports = __webpack_public_path__ + "static/media/MY-UMS.7a82943c.png";